
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.88 11.16C19.995 7.486 16.267 5 12 5c-4.268 0-7.997 2.487-9.88 6.16a1.123 1.123 0 000 1.014c1.884 3.674 5.612 6.16 9.88 6.16 4.268 0 7.997-2.488 9.88-6.16a1.124 1.124 0 000-1.014zM12 16.667a5 5 0 110-10 5 5 0 010 10zm0-8.334a3.31 3.31 0 00-.879.132 1.661 1.661 0 01-2.323 2.323A3.326 3.326 0 1012 8.333z","fill":"#282E3E"}})])
          )
        }
      }
    